import { RequestStatusBadge } from "@/components/common/section-components/badge/RequestStatusBadge";
import { ServiceRequestStatus } from "@/constants/entity-status";
import { SolicitudServicioDetail } from "@/services/service-requests.service";
import { AppColors } from "@/styles/colors";
import { formatCurrency } from "@/utils/format-currency";
import { Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import React from "react";

export const rowBg = (index: number) =>
  index % 2 === 0 ? AppColors.BACKGROUND_SECONDARY : "transparent";

interface UseSamplingRequestRowsParams {
  detail: SolicitudServicioDetail | null;
  cantidadLabel: string;
  cantidadFormatted: string;
  executedLabel: string;
  executedFormatted: string;
  showExecutionInfo: boolean;
  isMuestrasUnidad: boolean;
}

export interface SamplingRow {
  label: string;
  value: React.ReactNode;
}

export const useSamplingRequestRows = ({
  detail,
  cantidadLabel,
  cantidadFormatted,
  executedLabel,
  executedFormatted,
  showExecutionInfo,
  isMuestrasUnidad,
}: UseSamplingRequestRowsParams): {
  leftRows: SamplingRow[];
  rightRows: SamplingRow[];
} => {
  const leftRows: SamplingRow[] = [
    { label: "Cuenta Productor:", value: detail?.cuentaOrigen ?? "-" },
    { label: "Nombre:",           value: detail?.nombreUsuario ?? "-" },
    { label: "Sucursal:",         value: detail?.sucursal ?? "-" },
    { label: "Establecimiento:",  value: detail?.procedencia ?? "-" },
    { label: "Hectáreas:",        value: detail?.hectareas ?? "-" },
    ...(isMuestrasUnidad
      ? [{ label: `${cantidadLabel}:`, value: cantidadFormatted }]
      : []),
    ...(showExecutionInfo
      ? [{ label: `${executedLabel}:`, value: executedFormatted }]
      : []),
  ];

  const rightRows: SamplingRow[] = [
    {
      label: "Valor Unitario:",
      value: `$${formatCurrency(detail?.valorUnitario ?? 0)}`,
    },
    {
      label: "Valor total del servicio:",
      value: `$${formatCurrency(detail?.valorTotal ?? 0)}`,
    },
    {
      label: "Fecha deseada:",
      value: detail?.fechaDeseada
        ? dayjs(detail.fechaDeseada).format("DD/MM/YYYY")
        : "-",
    },
    {
      label: "Tipo:",
      value: (
        <Text
          className="account-value-label"
          title={detail?.tipoServicio ?? ""}
          flex="1"
          minW={0}
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
        >
          {detail?.tipoServicio ?? "-"}
        </Text>
      ),
    },
    {
      label: "Estado:",
      value: (
        <Text as="span" className="account-value-label">
          <RequestStatusBadge status={detail?.estado as ServiceRequestStatus} />
        </Text>
      ),
    },
    ...(showExecutionInfo
      ? [
          {
            label: "Fecha realización:",
            value: detail?.fechaRealizacion
              ? dayjs(detail.fechaRealizacion).format("DD/MM/YYYY")
              : "-",
          },
        ]
      : []),
  ];

  return { leftRows, rightRows };
};